<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div
    v-cloak
    class="d-flex  align-center justify-center flex-column"
    style="height: 100%;position: relative"
  >
    <div
      style="width: 70%;max-width: 480px;"
    >
      <template v-if="!waitLogin">
        <check-pin-code-fragment @passed="submitPinCode" />
      </template>
      <template v-else>
        <loading-card />
      </template>
      <div class="d-flex justify-center align-center mt-2">
        <a @click="resetPinCode">
          {{ $t('PinReset') }}
        </a>
      </div>
      <div
        class="d-flex flex-column align-center text-caption text--secondary"
        style="width: 100%;position: absolute;left: 0;right: 0;bottom: 48px;"
      >
        <div>
          Aaden POS v {{ version }}
        </div>
        <div>
          Copyright 2023, InnerKen All Rights Reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckPinCodeFragment from '@/views/widget/PINInput/CheckPinCodeFragment.vue'
import {
  getCurrentUserId,
  getPinCode,
  getUserCurrentStoreInfo,
  gotoLastRoute,
  usePinCode
} from '@/model/dataLayer/api/SaaS/user'
import LoadingCard from '@/views/widget/uiComponent/LoadingCard.vue'
import { FireBaseAuth } from '@/model/firebase/google-fire-base'
import GlobalConfig from '@/model/global/GlobalSettings'
import { useStore } from '@/model/dataLayer/api/SaaS/storeService'

export default {
  name: 'CheckPinCode',
  components: {
    LoadingCard,
    CheckPinCodeFragment
  },
  data () {
    return {
      waitLogin: false,
      version: require('../../../package.json').version,
      userCurrentPinCode: null
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    async resetPinCode () {
      await usePinCode(0)
      await FireBaseAuth.signOut()
      location.reload()
    },
    async submitPinCode () {
      this.waitLogin = true
      const mainStoreDevice = (await getUserCurrentStoreInfo())
      GlobalConfig.DeviceId = mainStoreDevice.currentStoreId
      await useStore(mainStoreDevice.currentStoreId, false)
      await gotoLastRoute()
      this.waitLogin = false
    },
    async reload () {
      if (getCurrentUserId()) {
        this.userCurrentPinCode = (await getPinCode())?.pinCode
      }
    }
  }
}
</script>

<style scoped>

</style>
